import { render, staticRenderFns } from "./ConfigExTable.vue?vue&type=template&id=56597fec&"
import script from "./ConfigExTable.vue?vue&type=script&lang=js&"
export * from "./ConfigExTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports